<div class="container2" [hidden]="loadPage">
    <div class="flex2">
        <div class="loader2">
        </div>
    </div>
    <div class="load-text2">
        <span></span>
    </div>
</div>



<div class="login-page">
    <div class="form">
        <div class="login-form">
            <input (keyup.enter)="login()" type="text" [(ngModel)]="user" autocomplete="off" placeholder="اسم المستخدم" />
            <input (keyup.enter)="login()" type="password" [(ngModel)]="pass" autocomplete="off" placeholder="كلمة المرور" />
            <button (click)="login()"> تسجيل دخول</button>
        </div>
    </div>
</div>